// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'video-off';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.031 1.031 16.97 16.97m-5.501-8.782V6.062A1.063 1.063 0 0 0 10.406 5H7.75m2.313 8.6h-7.97a1.063 1.063 0 0 1-1.062-1.063V6.162A1.063 1.063 0 0 1 2.094 5.1m12.243 6.709 1.832.915a.532.532 0 0 0 .768-.475V6.53a.53.53 0 0 0-.768-.475l-1.832.915a1.062 1.062 0 0 0-.587.95v2.937a1.062 1.062 0 0 0 .587.951z'
  />
);

export const viewBox = '0 0 18 18';
